module.exports = __webpack_public_path__ + "static/img/icon_obudowa_centrala.9ab936e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_obudowa_centrala.png
// module id = cu/b
// module chunks = 1